import React from 'react';
import TabBar from "../../TabBar";

class ConfigHome extends React.Component {

  render() {
    return (
      <div>
        <TabBar
          items={[
            { to: '/monitoring/config/status', label: 'Status' },
            { to: '/monitoring/config/reason', label: 'Reason' },
            { to: '/monitoring/config/action', label: 'Action' },
            { to: '/monitoring/config/work_order_status', label: 'Work Order Status' },
            { to: '/monitoring/config/priority', label: 'Priority' },
            { to: '/monitoring/config/maintenance_type', label: 'Maintenance Type' },
            { to: '/monitoring/config/email', label: 'SMTP' },
          ]}
        /><br/>
        {this.props.children}
      </div>
    );
  }
}

export default ConfigHome;


// WEBPACK FOOTER //
// ./src/components/Maintenance/Configuration/ConfigHome.js